<template>
  <v-dialog v-model="show" width="785px" persistent>
    <div class="modal">
      <v-card flat :loading="status == 'loading'">
        <ValidationObserver ref="validator">
          <v-row>
            <div class="icon-modal table-cell">
              <v-layout class="delete-warning-icon">
                <v-flex>
                  <img :src="require('@/assets/img/warning.svg')" alt=""/>
                </v-flex>
              </v-layout>
            </div>
            <v-col class="table-cell modal-content">
              <div class="d-flex justify-space-between">
                <h6 class="modal-title mb-5">Delete User</h6>
              </div>

              <p>This user will no longer have the ability to access KIEY.</p>

              <b>Are you sure you want to delete this user?</b>

              <div v-if="hasSomeOwner" class="mt-7">
                <label style="position: relative;
    top: -4px;">Assign a user to take over the Owner role:</label>
              </div>

              <div v-if="hasSomeOwner" class="custom-select-margin">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-select
                      :items="filteredOwner"
                      v-model="selectedOwner"
                      :error-messages="errors"
                      class="label-custom mt-0 pt-0 mr-3 pr-3 custom-input-position-text change_bord especial_border custom-select-options"
                      name="type"
                      type="text"
                      item-value="value"
                      item-text="text"
                      placeholder="Select one user"
                      :multiple="false"
                      :disabled="status_action === 'loading'"
                      :readonly="status_action === 'loading'"
                      @change="onChangeOwner"
                  >
                    <template v-slot:append>
                      <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>

              <div class="mt-10 mb-10 buttons d-flex">
                <v-btn
                    class="btn-blanco few mt-5"
                    rounded
                    depressed
                    @click="delete_client"
                    :disabled="status == 'loading'"
                    :loading="status == 'loading'"
                    style="width:160px"
                >Yes
                </v-btn>
                <v-btn
                    class="btn-azul few mt-5"
                    rounded
                    depressed
                    :disabled="status == 'loading'"
                    :loading="status == 'loading'"
                    @click="close"
                    style="width:160px"
                >No
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card>
    </div>
  </v-dialog>
</template>
<script>
  import {mapState, mapActions} from "vuex";
  import {ValidationObserver, ValidationProvider} from "vee-validate";

  export default {
    props: ['show', 'hide', 'selected'],
    components: {ValidationObserver, ValidationProvider},
    computed: {
      ...mapState({
        status: state => state.Vendors_list.status,
        user: state => state.Authenticate.user,
        dataUsers: state => state.Vendors_list.list_users,
      }),
      hasSomeOwner() {
        return this.selected.find(x => ["vendor", "owner"].includes(x.user_role))
      },
    },
    data() {
      return {
        selectedUser: null,
        filteredAgent: [],
        filteredOwner: [],
        selectedOwner: null
      }
    },
    watch: {
      selected(data) {
        const self = this;
        self.filteredAgent = [];
        for (const agent of self.dataUsers.map(x => {
          return {text: `${x.name}`, value: x.owner_id}
        })) {
          if (data.findIndex(a => a.owner_id === agent.value) === -1) {
            self.filteredAgent.push(agent);
          }
        }

        self.filteredOwner = [];
        for (const agent of self.dataUsers.filter(x => x.status === "Active" || x.status === undefined).map(x => {
          return {text: `${x.name}`, value: x.owner_id}
        })) {
          if (data.findIndex(a => a.owner_id === agent.value) === -1) {
            self.filteredOwner.push({
              ...agent
            });
          }
        }
      },
      filteredAgent(data) {
        const self = this;
        self.selectedUser = null;

        if (data.length > 0) {
          self.selectedUser = data[0]['value'];
        }
      },
      filteredOwner(data) {
        const self = this;
        self.selectedOwner = null;

        if (data.length > 0) {
          self.selectedOwner = data[0]['value'];
        }
      },
    },
    methods: {
      onChangeOwner(data) {
        const self = this;
        self.selectedOwner = data;
      },
      onChangeSelected(data) {
        const self = this;
        self.selectedUser = data;
      },
      ...mapActions({get_users: "Vendors_list/get_users"}),
      close: function () {
        this.hide();
      },
      setter() {
        const self = this;
        self.$emit("setter");
      },
      async delete_client() {
        if (!await this.$refs.validator.validate()) {
          return;
        }
        const self = this;
        self.$store.dispatch('Vendors_list/delete', {
          transfer_to: "not_transfer",
          users: self.selected,
          transfer_owner: self.selectedOwner
        }).then(function (response) {
          if (response) {
            self.close();
            self.$store.dispatch("Vendors_list/clear_data");
            self.setter();
            self.get_users("employee");
          }
        });
      }
    },
  };
</script>